import React, { FC, useState } from 'react';
import { Button, ButtonGroup, Modal, ToggleButton } from 'react-bootstrap';
import { useTransLog } from '../contexts/TransLogContext';
import JsonView from 'react18-json-view';
import Spinner from 'react-bootstrap/Spinner';
import 'react18-json-view/src/style.css';

const jsonDisplay = [
    { name: 'Raw', value: '1' },
    { name: 'Beautify', value: '2' }
];

const TransLogDetailModal = ({ show, handleClose }: { show: boolean, handleClose: () => void }) => {
    const rows = 20;
    const { detail, detailLog, detailNotFound } = useTransLog();
    const [radioValue, setRadioValue] = useState('1');

    return (
        <>
            <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>SAP Log Detail - {detailLog.id} - {detailLog.applicationName} - {detailLog.transactionType}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {detailNotFound ? <>SAP Detail Not found</> : (detail ?
                        <>
                            <ButtonGroup className="mb-2">
                                {jsonDisplay.map((radio, idx) => (
                                    <ToggleButton
                                        key={idx}
                                        id={`radio-${idx}`}
                                        type="radio"
                                        variant="secondary"
                                        name="radio"
                                        value={radio.value}
                                        checked={radioValue === radio.value}
                                        onChange={(e) => setRadioValue(e.currentTarget.value)}
                                    >
                                        {radio.name}
                                    </ToggleButton>
                                ))}
                            </ButtonGroup>
                            {radioValue === '1' ?
                                <>
                                    <br /><textarea style={{ width: "100%" }} rows={rows} value={JSON.stringify(detail)} />
                                </> :
                                <JsonView src={detail as any} />}
                        </>
                        : <Spinner animation="border" variant="secondary" />)
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default TransLogDetailModal;